export const protocol = {
  isValid: [{
    value: 1, label: '有效'}, {
    value: 2, label: '无效'}, {
    value: 3, label: '已过期'}, {
    value: 4, label: '未生效'
  }],
  dateType: [{
    value: 1, label: '签订日期'}, {
    value: 2, label: '协议开始日期'}, {
    value: 3, label: '协议结束日期'
  }]
}

export default {
  protocol
}



// WEBPACK FOOTER //
// ./src/data/protocol.js